/**
 * Русское число при существительном: 1 реплика, 2 реплики, 5 реплик, 11 реплик, 21 реплика.
 * Проба P50m10: тост редактора «плохая озвучка (1 реплик)» — так говорили все места, где редактор и отчёт
 * правки выводят число реплик.
 */
export const pluralRu = (n: number, one: string, few: string, many: string): string => {
    const abs = Math.abs(Math.trunc(Number(n) || 0));
    const d = abs % 10;
    const h = abs % 100;
    if (d === 1 && h !== 11) return one;
    if (d >= 2 && d <= 4 && !(h >= 12 && h <= 14)) return few;
    return many;
};

/** «1 реплика», «3 реплики», «5 реплик». */
export const cuesRu = (n: number): string => `${n} ${pluralRu(n, "реплика", "реплики", "реплик")}`;

/** «1 новая реплика», «3 новые реплики», «5 новых реплик». */
export const newCuesRu = (n: number): string =>
    `${n} ${pluralRu(n, "новая реплика", "новые реплики", "новых реплик")}`;

/**
 * Отчёт правки от сервера, написанный до исправления склонения: «найдено: плохая озвучка (1 реплик)» —
 * число в скобках со словом «реплик» склоняется здесь (новые отчёты сервер пишет уже верно).
 */
export const fixCueCounts = (text: string): string =>
    text.replace(/\((\d+) реплик\)/g, (_all, num: string) => `(${cuesRu(Number(num))})`);

/** Родительный падеж после «до»: «до 1 реплики», «до 3 реплик», «до 5 реплик». */
export const cuesRuGen = (n: number): string => `${n} ${pluralRu(n, "реплики", "реплик", "реплик")}`;
